import IResourceLoader from '../types/IResourceLoader'
import useCallbackRef from './useCallbackRef'
import useResourceLoader from './useResourceLoader'
import { IGuardingActivitiesData } from '../types/GuardingActivity/IGuardingActivityType'
import { useApiClient } from '../context/AppContext'
import guardingApi from '../api/guardingApi'

const useGuardingTasks = (): [IResourceLoader<IGuardingActivitiesData>, any] => {
  const apiClient = useApiClient()

  const resource = useResourceLoader<IGuardingActivitiesData>(
    'Unable to load guarding tasks'
  )

  const loader = useCallbackRef(
    async (page: number, storeCode: string): Promise<IGuardingActivitiesData> => {
      return resource.load(async () =>
        guardingApi.GetGuardingActivities(apiClient, page, storeCode)
      )
    })

  return [resource, loader]
}

export default useGuardingTasks